import { CustomError } from "./CustomError";

export class ValidationError extends CustomError {
  constructor(
    public readonly fieldErrors: Record<string, string>,
    message = "Validation Error",
  ) {
    super(message);
  }
}
